<template>
    <div class="top-table-filter-container">
        <!-- Десктопная версия -->
        <div class="d-none d-md-flex">
            <!-- Группа фильтрации по типу -->
            <div class="green-filter d-flex mb-2" v-if="!isAgent">
                <span 
                    v-for="(item, index) in greenFilterMenu"
                    :key="index"
                    :class="`mr-2 ${item.active ? 'green-link active' : 'green-link'}`"
                    style="font-size: 12px;"
                    @click="changeActive(index)"
                >
                    {{ item.title }}
                </span>
                <span 
                    v-if="!isB2CAccount && !isAgent && !isClient"
                    class="green-link" 
                    style="font-size: 12px;"
                    title="Виртуальные счета"
                    @click="showFinanceVirtual"
                >Виртуальные</span>
            </div>

            <!-- Группа фильтрации по оплате -->
            <div 
                class="green-filter d-flex mb-2"
                :class="{ 'ml-4': !isAgent }"
            >
                <span 
                    v-for="(item, index) in paymentFilterMenu" 
                    :key="'pay-' + index" 
                    :class="`mr-2 ${item.active ? 'green-link active' : 'green-link'}`" 
                    style="font-size: 12px;"
                    @click="changePaymentFilter(index)"
                >
                    {{ item.title }}
                </span>
            </div>

            <!-- Кнопка фильтрации "Не предоставлены" -->
            <div class="green-filter d-flex mb-2 ml-3">
                <span 
                    :class="`mr-2 ${notProvidedToggle ? 'green-link active' : 'green-link'}`" 
                    style="font-size: 12px;"
                    @click="toggleNotProvided"
                >
                    Не предоставлены
                </span>
            </div>
        </div>

        <!-- Мобильная версия -->
        <div class="d-flex d-md-none mobile-filter-container">
            <!-- Бургер-меню -->
            <button 
                class="burger-menu-btn"
                @click="toggleMobileMenu"
                :class="{ active: isMobileMenuOpen }"
            >
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>

            <!-- Выпадающее меню -->
            <div class="mobile-dropdown" :class="{ show: isMobileMenuOpen }">
                <div class="mobile-filter-section" v-if="!isAgent">
                    <h6 class="mobile-filter-title">Тип</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in greenFilterMenu"
                            :key="index"
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changeActive(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                        <span 
                            v-if="!isB2CAccount && !isAgent && !isClient"
                            class="mobile-filter-item"
                            @click="showFinanceVirtual(); closeMobileMenu()"
                        >
                            Виртуальные
                        </span>
                    </div>
                </div>

                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Оплата</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in paymentFilterMenu" 
                            :key="'pay-' + index" 
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changePaymentFilter(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                    </div>
                </div>

                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Предоставлены</h6>
                    <div class="mobile-filter-items">
                        <span 
                            :class="`mobile-filter-item ${notProvidedToggle ? 'active' : ''}`"
                            @click="toggleNotProvided(); closeMobileMenu()"
                        >
                            Не предоставлены
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";

    export default {
        props: {
            api: {type: String, required: true},              // Link on API for table working
        },
        data() {
            return {
                additionalParameter: '',
                additionalPaymentStatus: '',
                isMobileMenuOpen: false,
                greenFilterMenu: [
                    {title: "Все", active: true},
                    {title: "Покупатель", active: false, invoice_type: 'incoming'},
                    {title: "Поставщик", active: false, invoice_type: 'outgoing'}
                ],
                paymentFilterMenu: [
                    { title: "Оплаченные", active: false, payment_status: 'paid' },
                    { title: "Не оплаченные", active: false, payment_status: 'unpaid' }
                ],
                notProvidedToggle: false,
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),

            isB2CAccount() {
                return this.currentUser.role.includes('b2c-head-manager') || 
                        this.currentUser.role.includes('b2c-manager');
            },

            isAgent() {
                return this.currentUser.role.includes('agent');
            },

            isClient() {
                return this.currentUser.role.includes('client');
            }
        },
        mounted() {
            this.changeActive(this.$store.state.userLocalSettings.filterSettings.financeTable)
        },
        methods: {
            changeActive(activeIndex) {
                this.additionalParameter = '';
                this.changePaymentFilter(-1);
                this.notProvidedToggle = false;

                this.$store.dispatch("userLocalSettings/SET_FILTER_SETTINGS", {
                    name: 'financeTable',
                    value: activeIndex
                });

                this.greenFilterMenu.forEach((item, index) => {
                    item.active = false;

                    if (activeIndex == index) {
                        item.active = true;
                        if (item.invoice_type) {
                            this.additionalParameter = '&invoice_type=' + item.invoice_type;
                        }

                        this.$emit('setFilteringApiParameter', this.additionalParameter);
                    }
                })
            },

            // Переключение по "Оплате"
            changePaymentFilter(activeIndex) {
                this.additionalPaymentStatus = '';

                this.paymentFilterMenu.forEach((item, index) => {
                    item.active = false;

                    if (activeIndex == index) {
                        item.active = true;

                        this.additionalPaymentStatus = `&payment_status=${item.payment_status}`;

                        this.$emit('setFilteringApiParameter', `${this.additionalParameter}${this.additionalPaymentStatus}${this.getNotProvidedParameter()}`)
                    }
                });
            },

            // Переключение кнопки "Не предоставлены"
            toggleNotProvided() {
                this.notProvidedToggle = !this.notProvidedToggle;
                this.$emit('setFilteringApiParameter', `${this.additionalParameter}${this.additionalPaymentStatus}${this.getNotProvidedParameter()}`)
            },

            // Получить параметр для "Не предоставлены"
            getNotProvidedParameter() {
                return this.notProvidedToggle ? '&provision_status=not_provided' : '';
            },
            showFinanceVirtual() {
                this.$emit('universalEmit', 'showFinanceVirtual');
            },

            // Методы для мобильного меню
            toggleMobileMenu() {
                this.isMobileMenuOpen = !this.isMobileMenuOpen;
            },

            closeMobileMenu() {
                this.isMobileMenuOpen = false;
            },
        }
    }
</script>